import { Modal } from "@findemdev/maui"
import { CredentialLibraryType, ICredential } from "../../../types/credential";

interface IMarqueeToggleProps {
  open: boolean;
  credential: ICredential;
  isPending: boolean;
  onOk: () => Promise<void>;
  onCancel: () => void;
}


const MarqueeToggle = ({ open, credential, isPending, onCancel, onOk }: IMarqueeToggleProps) => {
  const isMarqueeCred = credential.libraries?.includes(CredentialLibraryType.MARQUEE_LIBRARY);

  return <Modal
    open={open}
    title={isMarqueeCred ? "Unmark as Marquee" : "Mark as Marquee"}
    okButtonProps={{ loading: isPending, disabled: isPending }}
    onOk={onOk}
    onCancel={onCancel}
  >
    {isMarqueeCred
      ? "Are you sure you want to unmark this credential as a Marquee credential? It will be removed from the Marquee."
      : "Are you sure you want to mark this credential as a Marquee credential? It will be added to the Marquee."
    }
  </Modal>
}

export default MarqueeToggle;